/* Decca theme behaviour. No dependencies. */
(function () {
  'use strict';

  var D = window.Decca || {};

  function formatMoney(cents) {
    if (typeof cents === 'string') cents = cents.replace('.', '');
    cents = Number(cents) || 0;
    var fmt = D.moneyFormat || '${{amount}}';
    function withDelims(n, precision, thousands, decimal) {
      var parts = (n / 100).toFixed(precision).split('.');
      parts[0] = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands);
      return parts.length > 1 ? parts[0] + decimal + parts[1] : parts[0];
    }
    return fmt.replace(/\{\{\s*(\w+)\s*\}\}/, function (_, key) {
      switch (key) {
        case 'amount_no_decimals': return withDelims(cents, 0, ',', '.');
        case 'amount_with_comma_separator': return withDelims(cents, 2, '.', ',');
        case 'amount_no_decimals_with_comma_separator': return withDelims(cents, 0, '.', ',');
        default: return withDelims(cents, 2, ',', '.');
      }
    });
  }
  /* Short money: drop .00 like the design ($36, $28.80) */
  function money(cents) { return formatMoney(cents).replace(/\.00(?!\d)/, ''); }
  D.money = money;

  function $(sel, root) { return (root || document).querySelector(sel); }
  function $$(sel, root) { return Array.prototype.slice.call((root || document).querySelectorAll(sel)); }
  function json(url, opts) {
    return fetch(url, Object.assign({ headers: { 'Content-Type': 'application/json', Accept: 'application/json' } }, opts || {}))
      .then(function (r) { return r.json().then(function (data) { if (!r.ok) throw data; return data; }); });
  }

  /* ---------- Header: mobile menu ---------- */
  document.addEventListener('click', function (e) {
    var t = e.target.closest('[data-menu-toggle]');
    if (!t) return;
    var menu = document.getElementById(t.getAttribute('aria-controls'));
    if (!menu) return;
    setMenu(menu, !menu.classList.contains('is-open'));
  });
  function setMenu(menu, open) {
    menu.classList.toggle('is-open', open);
    document.documentElement.classList.toggle('menu-open', open);
    $$('[data-menu-toggle][aria-controls="' + menu.id + '"]').forEach(function (b) { b.setAttribute('aria-expanded', String(open)); });
    if (open) { var c = menu.querySelector('.mobile-menu__close'); if (c) c.focus(); }
  }
  /* Close the menu when one of its links is used (incl. opening the cart) or on Escape */
  document.addEventListener('click', function (e) {
    var menu = e.target.closest('.mobile-menu.is-open');
    if (menu && e.target.closest('a')) setMenu(menu, false);
  });
  document.addEventListener('keydown', function (e) {
    if (e.key !== 'Escape') return;
    var menu = document.querySelector('.mobile-menu.is-open');
    if (menu) setMenu(menu, false);
  });

  /* ---------- Hero video pause ---------- */
  document.addEventListener('click', function (e) {
    var b = e.target.closest('[data-video-toggle]');
    if (!b) return;
    var v = b.closest('.hero').querySelector('video');
    if (!v) return;
    if (v.paused) { v.play(); b.setAttribute('aria-label', 'Pause background video'); b.innerHTML = b.dataset.pauseIcon; }
    else { v.pause(); b.setAttribute('aria-label', 'Play background video'); b.innerHTML = b.dataset.playIcon; }
  });
  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
    $$('.hero video[autoplay]').forEach(function (v) { v.pause(); });
  }

  /* ---------- Decaf switch ---------- */
  document.addEventListener('click', function (e) {
    var b = e.target.closest('[data-switch-mode]');
    if (!b) return;
    var sec = b.closest('[data-switch]');
    var wired = b.dataset.switchMode === 'wired';
    sec.classList.toggle('is-wired', wired);
    $$('[data-switch-mode]', sec).forEach(function (x) { x.setAttribute('aria-pressed', String(x === b)); });
    $$('[data-wired]', sec).forEach(function (el) {
      if (!el.dataset.decaf) el.dataset.decaf = el.textContent;
      el.textContent = wired ? el.dataset.wired : el.dataset.decaf;
    });
  });

  /* ---------- Buy module ---------- */
  function BuyModule(root) {
    this.root = root;
    var data = JSON.parse($('script[data-buy-json]', root).textContent);
    this.product = data.product;
    this.flavors = data.flavors || {};
    this.cfg = data.config || {};
    this.optFlavor = this.product.options.findIndex(function (o) { return /flavou?r/i.test(o.name || o); });
    this.optPack = this.product.options.findIndex(function (o) { return /pack|size|cans|count/i.test(o.name || o); });
    this.plans = [];
    var self = this;
    (this.product.selling_plan_groups || []).forEach(function (g) {
      g.selling_plans.forEach(function (p) { self.plans.push(p); });
    });
    var initial = this.product.variants.find(function (v) { return v.id === data.selected_variant_id; }) || this.product.variants[0];
    var defaultPlan = this.plans.length ? (this.plans[this.cfg.default_plan_index || 0] || this.plans[0]) : null;
    this.state = {
      options: initial.options.slice(),
      plan: this.plans.length && this.cfg.subscribe_default !== false ? 'sub' : 'one',
      freqKey: defaultPlan ? planKey(defaultPlan) : null,
      planId: null,
      shot: 0
    };
    this.bind();
    this.render();
  }

  BuyModule.prototype.variant = function () {
    var o = this.state.options;
    return this.product.variants.find(function (v) { return v.options.every(function (val, i) { return val === o[i]; }); });
  };

  BuyModule.prototype.flavorKey = function () {
    if (this.optFlavor < 0) return null;
    return handleize(this.state.options[this.optFlavor]);
  };

  BuyModule.prototype.flavor = function (key) {
    key = key || this.flavorKey();
    return this.flavors[key] || null;
  };

  BuyModule.prototype.shots = function () {
    var key = this.flavorKey();
    var f = this.flavor();
    var name = this.optFlavor >= 0 ? this.state.options[this.optFlavor] : '';
    var media = (this.product.media || []).filter(function (m) { return m.media_type === 'image'; });
    var matched = name ? media.filter(function (m) { return (m.alt || '').toLowerCase().indexOf(name.toLowerCase()) > -1; }) : [];
    var v = this.variant();
    if (!matched.length && v && v.featured_media) matched = [v.featured_media];
    if (!matched.length && f && f.photos && f.photos.length) {
      return f.photos.map(function (src, i) { return { src: src, thumb: src, label: (f.shots || [])[i] || '', cap: (f.caps || [])[i] || '', ov: (f.overlays || [])[i] || '' }; });
    }
    if (!matched.length) matched = media;
    return matched.slice(0, 4).map(function (m, i) {
      var src = m.preview_image ? m.preview_image.src : m.src;
      return { src: sized(src, 1200), thumb: sized(src, 300), label: (f && f.shots ? f.shots[i] : '') || m.alt || '', cap: (f && f.caps ? f.caps[i] : '') || '', ov: (f && f.overlays ? f.overlays[i] : '') || '' };
    });
  };

  function sized(src, w) {
    if (!src) return src;
    return src + (src.indexOf('?') > -1 ? '&' : '?') + 'width=' + w;
  }
  function handleize(s) {
    return String(s || '').toLowerCase().replace(/['’"]/g, '').replace(/[^a-z0-9]+/g, '-').replace(/^-|-$/g, '');
  }
  D.handleize = handleize;

  BuyModule.prototype.cansPerUnit = function () {
    if (this.optPack > -1) {
      var n = parseInt(this.state.options[this.optPack], 10);
      if (n) return n;
    }
    return Number(this.cfg.cans_per_unit) || 12;
  };

  BuyModule.prototype.bind = function () {
    var self = this;
    this.root.addEventListener('click', function (e) {
      var b;
      if ((b = e.target.closest('[data-opt-index]'))) {
        if (b.disabled) return;
        self.state.options[Number(b.dataset.optIndex)] = b.dataset.value;
        if (Number(b.dataset.optIndex) === self.optFlavor) self.state.shot = 0;
        self.ensureVariant(Number(b.dataset.optIndex));
        self.render();
      } else if ((b = e.target.closest('[data-plan]'))) {
        self.state.plan = b.dataset.plan;
        self.render();
      } else if ((b = e.target.closest('[data-freq-key]'))) {
        self.state.freqKey = b.dataset.freqKey;
        self.render();
      } else if ((b = e.target.closest('[data-shot]'))) {
        self.state.shot = Number(b.dataset.shot);
        self.renderGallery();
      } else if ((b = e.target.closest('[data-shot-step]'))) {
        var n = self.shots().length || 1;
        self.state.shot = (self.state.shot + Number(b.dataset.shotStep) + n) % n;
        self.renderGallery();
      }
    });
    this.root.addEventListener('change', function (e) {
      if (e.target.matches('[data-sub-switch]')) { self.state.plan = e.target.checked ? 'sub' : 'one'; self.render(); }
    });
    var form = $('form[data-buy-form]', this.root);
    if (form) form.addEventListener('submit', function (e) { e.preventDefault(); self.add(); });
  };

  /* If the chosen combination doesn't exist, pick the first variant that matches the option just changed */
  BuyModule.prototype.ensureVariant = function (changedIndex) {
    if (this.variant()) return;
    var val = this.state.options[changedIndex];
    var v = this.product.variants.find(function (x) { return x.options[changedIndex] === val && x.available; }) ||
      this.product.variants.find(function (x) { return x.options[changedIndex] === val; });
    if (v) this.state.options = v.options.slice();
  };

  /* Plans can differ per variant (e.g. one plan group per pack size), so resolve the plan from the chosen frequency */
  function planKey(p) {
    var o = p.options && p.options[0];
    return String((o && (o.value || o)) || p.name || '').toLowerCase().trim();
  }
  BuyModule.prototype.variantPlans = function (v) {
    var ids = (v.selling_plan_allocations || []).map(function (a) { return a.selling_plan_id; });
    return this.plans.filter(function (p) { return ids.indexOf(p.id) > -1; });
  };
  BuyModule.prototype.currentPlan = function (v) {
    var vp = this.variantPlans(v), key = this.state.freqKey;
    return vp.find(function (p) { return planKey(p) === key; }) || vp[this.cfg.default_plan_index || 0] || vp[0] || null;
  };
  BuyModule.prototype.allocation = function (v) {
    var id = this.state.planId;
    return (v.selling_plan_allocations || []).find(function (a) { return a.selling_plan_id === id; });
  };

  BuyModule.prototype.render = function () {
    var self = this, root = this.root, s = this.state;
    var v = this.variant();
    var f = this.flavor();

    /* Option buttons */
    $$('[data-opt-index]', root).forEach(function (b) {
      var i = Number(b.dataset.optIndex);
      b.setAttribute('aria-pressed', String(s.options[i] === b.dataset.value));
      var probe = s.options.slice(); probe[i] = b.dataset.value;
      var exists = self.product.variants.some(function (x) { return x.options.every(function (val, k) { return val === probe[k]; }); });
      var anyWithValue = self.product.variants.some(function (x) { return x.options[i] === b.dataset.value; });
      b.disabled = !anyWithValue;
      b.classList.toggle('is-unavailable', !exists);
    });

    /* Copy */
    var title = $('[data-buy-title]', root);
    if (title) title.textContent = f && f.name ? f.name : (this.optFlavor > -1 ? s.options[this.optFlavor] : this.product.title);
    var copy = $('[data-buy-copy]', root);
    if (copy && f) copy.textContent = f.copy || '';
    var chips = $('[data-buy-chips]', root);
    if (chips) chips.innerHTML = ((f && f.chips) || []).map(function (c) { return '<span>' + esc(c) + '</span>'; }).join('');
    var badge = $('[data-start-here]', root);
    if (badge) badge.hidden = !(f && f.popular);
    var stage = $('.stage', root);
    if (stage && f && f.swatch) stage.style.background = f.swatch;
    $$('[data-crumb-current]').forEach(function (el) { el.textContent = (title ? title.textContent : '').toUpperCase(); });
    document.dispatchEvent(new CustomEvent('decca:flavor', { detail: { key: this.flavorKey(), flavor: f } }));

    /* Prices */
    var input = $('input[name="id"]', root);
    var btn = $('[data-buy-submit]', root);
    if (!v) {
      if (btn) { btn.disabled = true; btn.textContent = D.strings.soldOut || 'Unavailable'; }
      return;
    }
    if (input) input.value = v.id;
    var vPlans = this.variantPlans(v);
    var plan = this.currentPlan(v);
    s.planId = plan ? plan.id : null;
    var subMode = s.plan === 'sub' && !!plan;
    var hasPlans = vPlans.length > 0;
    var alloc = hasPlans ? this.allocation(v) : null;
    var subPrice = alloc ? alloc.price : null;
    var subWas = alloc ? (alloc.compare_at_price || v.price) : v.price;
    var cans = this.cansPerUnit();
    var pct = 0;
    if (alloc && subWas) pct = Math.round((1 - subPrice / subWas) * 100);

    setText('[data-one-price]', money(v.price));
    setText('[data-sub-was]', money(subWas));
    setText('[data-sub-price]', subPrice != null ? money(subPrice) : '');
    setText('[data-sub-pct]', pct ? pct + '%' : '');
    setText('[data-sub-save]', subPrice != null ? money(subWas - subPrice) : '');
    setText('[data-sub-amt]', subPrice != null && subWas > subPrice ? '(' + money(subWas - subPrice) + ')' : '');
    setText('[data-sub-percan]', subPrice != null ? money(Math.round(subPrice / cans)) : '');
    setText('[data-sub-freq]', plan ? plan.name.split(',')[0].toLowerCase().replace(/^(delivery |deliver )?/, '') : '');
    $$('[data-sub-pct-wrap]', root).forEach(function (el) { el.hidden = !pct; });

    /* Switch-style subscribe row, savings line and price row */
    var weeks = plan ? parseInt((String(plan.name).match(/(\d+)\s*week/i) || [])[1], 10) || 4 : 4;
    var perDelivery = subPrice != null ? subWas - subPrice : 0;
    var sw = $('[data-sub-switch]', root);
    if (sw) { sw.checked = subMode; sw.disabled = !hasPlans; }
    var row = $('[data-subrow]', root);
    if (row) row.classList.toggle('is-off', !subMode);
    setText('[data-sub-title]', subMode ? 'Subscribe & save ' + pct + '%' : 'One-time purchase');
    setText('[data-sub-note]', subMode ? 'No commitment. Free shipping. Skip or cancel anytime.'
      : (hasPlans ? 'Want to save ' + pct + '%? Switch to subscribe.' : 'Subscriptions start at the 12-pack.'));
    var saving = $('[data-saving]', root);
    if (saving) {
      saving.hidden = !hasPlans || !perDelivery;
      var yearly = money(Math.round(perDelivery * 52 / weeks));
      saving.innerHTML = subMode
        ? 'You save ' + money(perDelivery) + ' every delivery. <span class="saving__yr">That’s about ' + yearly + ' a year.</span>'
        : 'Subscribe every ' + weeks + ' weeks and <span class="saving__yr">save about ' + yearly + ' a year.</span>';
    }
    setText('[data-mode-label]', subMode
      ? 'Every ' + weeks + ' weeks · ' + money(Math.round(subPrice / cans)) + '/can'
      : 'One-time · ' + money(Math.round(v.price / cans)) + '/can');
    setText('[data-mode-was]', subMode ? money(v.price) : '');
    setText('[data-mode-now]', money(subMode ? subPrice : v.price));

    var vKeys = vPlans.map(planKey);
    $$('[data-plan]', root).forEach(function (b) {
      b.setAttribute('aria-pressed', String(b.dataset.plan === (subMode ? 'sub' : 'one')));
      if (b.dataset.plan === 'sub') b.hidden = !hasPlans;
    });
    $$('[data-freq-key]', root).forEach(function (b) {
      b.hidden = vKeys.indexOf(b.dataset.freqKey) < 0;
      b.setAttribute('aria-pressed', String(!!plan && b.dataset.freqKey === planKey(plan)));
    });
    var freq = $('[data-freq]', root);
    if (freq) freq.hidden = !subMode || vPlans.length < 2;

    var spInput = $('input[name="selling_plan"]', root);
    if (spInput) spInput.value = subMode ? s.planId : '';

    if (btn) {
      btn.disabled = !v.available;
      if (!v.available) btn.textContent = D.strings.soldOut || 'Sold out';
      else if (subMode && subPrice != null) btn.textContent = (this.cfg.one_cta || 'Pre-order') + ' · ' + money(subPrice) + (plan ? ' / ' + shortFreq(plan.name) : '');
      else btn.textContent = (this.cfg.one_cta || 'Add to cart') + ' · ' + money(v.price);
    }

    /* Keep the URL in sync on the product page */
    if (this.cfg.update_url && window.history.replaceState) {
      var url = new URL(window.location.href);
      url.searchParams.set('variant', v.id);
      window.history.replaceState({}, '', url.toString());
    }

    this.renderGallery();

    function setText(sel, txt) { $$(sel, root).forEach(function (el) { el.textContent = txt; }); }
  };

  function shortFreq(name) {
    var m = String(name).match(/(\d+)\s*(week|month|day)/i);
    var unit = m ? { week: 'WKS', month: 'MO', day: 'DAYS' }[m[2].toLowerCase()] : '';
    return m ? m[1] + ' ' + unit : name;
  }

  BuyModule.prototype.renderGallery = function () {
    var root = this.root, s = this.state;
    var shots = this.shots();
    if (!shots.length) return;
    if (s.shot >= shots.length) s.shot = 0;
    var cur = shots[s.shot];
    var img = $('[data-stage-img]', root);
    if (img) {
      img.src = cur.src;
      img.removeAttribute('srcset');
      img.alt = ($('[data-buy-title]', root) || {}).textContent + (cur.label ? ': ' + cur.label.toLowerCase() : '');
    }
    var cap = $('[data-stage-cap]', root);
    if (cap) { cap.textContent = cur.cap; cap.hidden = !cur.cap; }
    var ov = $('[data-stage-ov]', root);
    if (ov) {
      var parts = (cur.ov || '').split('~');
      $('[data-stage-ov-h]', ov).innerHTML = esc(parts[0] || '').split('/').join('<br>');
      $('[data-stage-ov-p]', ov).innerHTML = esc(parts[1] || '').split('/').join('<br>');
      ov.hidden = !parts[0];
    }
    var count = $('[data-stage-count]', root);
    if (count) count.textContent = (s.shot + 1) + ' / ' + shots.length;
    var thumbs = $('[data-thumbs]', root);
    if (thumbs) {
      thumbs.innerHTML = shots.map(function (sh, i) {
        return '<button type="button" data-shot="' + i + '" aria-pressed="' + (i === s.shot) + '" aria-label="Photo ' + (i + 1) + (sh.label ? ': ' + esc(sh.label) : '') + '"><img src="' + esc(sh.thumb) + '" alt="" loading="lazy" width="300" height="300"></button>';
      }).join('');
    }
  };

  BuyModule.prototype.add = function () {
    var self = this, btn = $('[data-buy-submit]', this.root), err = $('[data-buy-error]', this.root);
    var v = this.variant();
    if (!v) return;
    var item = { id: v.id, quantity: 1 };
    if (this.state.plan === 'sub' && this.state.planId && this.variant() && this.currentPlan(this.variant())) item.selling_plan = this.state.planId;
    if (btn) btn.disabled = true;
    if (err) err.textContent = '';
    json(D.routes.cartAdd + '.js', { method: 'POST', body: JSON.stringify({ items: [item] }) })
      .then(function () { return Cart.open(); })
      .catch(function (e) { if (err) err.textContent = (e && (e.description || e.message)) || 'Could not add to cart.'; })
      .then(function () { if (btn) btn.disabled = !v.available; });
  };

  function esc(s) {
    return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]; });
  }

  /* ---------- Cart drawer ---------- */
  var Cart = {
    el: null,
    lastFocus: null,
    init: function () {
      this.el = document.getElementById('CartDrawer');
      if (!this.el) return;
      var self = this;
      document.addEventListener('click', function (e) {
        if (e.target.closest('[data-cart-open]')) { e.preventDefault(); self.open(); }
        else if (e.target.closest('[data-cart-close]')) { e.preventDefault(); self.close(); }
        else if (e.target.closest('[data-line-qty]')) {
          var b = e.target.closest('[data-line-qty]');
          self.change({ line: Number(b.dataset.line), quantity: Number(b.dataset.lineQty) });
        } else if (e.target.closest('[data-line-plan]')) {
          var u = e.target.closest('[data-line-plan]');
          self.change({ line: Number(u.dataset.line), quantity: Number(u.dataset.qty), selling_plan: Number(u.dataset.linePlan) });
        }
      });
      document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && self.el.classList.contains('is-open')) self.close(); });
    },
    open: function () {
      if (!this.el) { window.location.href = D.routes.cart; return Promise.resolve(); }
      this.lastFocus = document.activeElement;
      this.el.classList.add('is-open');
      this.el.setAttribute('aria-hidden', 'false');
      document.body.classList.add('drawer-open');
      var self = this;
      return this.refresh().then(function () { var c = $('[data-cart-close].drawer__close', self.el); if (c) c.focus(); });
    },
    close: function () {
      this.el.classList.remove('is-open');
      this.el.setAttribute('aria-hidden', 'true');
      document.body.classList.remove('drawer-open');
      if (this.lastFocus) this.lastFocus.focus();
    },
    change: function (body) {
      var self = this;
      return json(D.routes.cartChange + '.js', { method: 'POST', body: JSON.stringify(body) }).then(function (cart) { return self.render(cart); });
    },
    refresh: function () {
      var self = this;
      return json(D.routes.cart + '.js').then(function (cart) { return self.render(cart); });
    },
    plansFor: {},
    render: function (cart) {
      var self = this;
      $$('[data-cart-count]').forEach(function (el) { el.textContent = cart.item_count; });
      if (!this.el) return;
      setTextIn(this.el, '[data-drawer-count]', cart.item_count);
      setTextIn(this.el, '[data-drawer-total]', money(cart.total_price));

      var anySub = cart.items.some(function (i) { return i.selling_plan_allocation; });
      var ship = $('[data-drawer-ship]', this.el);
      var threshold = D.freeShippingThreshold || 0;
      if (ship) {
        var msg = ship.dataset;
        if (!cart.item_count) ship.hidden = true;
        else {
          ship.hidden = false;
          var html;
          if (anySub && msg.subMsg) html = esc(msg.subMsg);
          else if (threshold && cart.total_price < threshold) {
            var pct = Math.min(100, Math.round(cart.total_price / threshold * 100));
            html = esc((msg.awayMsg || '').replace('[amount]', money(threshold - cart.total_price))) + '<div class="drawer__bar"><span style="width:' + pct + '%"></span></div>';
          } else if (threshold) html = esc(msg.freeMsg || '');
          else html = esc(msg.defaultMsg || '');
          ship.innerHTML = html;
          ship.hidden = !html;
        }
      }

      var list = $('[data-drawer-items]', this.el);
      var foot = $('[data-drawer-foot]', this.el);
      if (foot) foot.hidden = !cart.item_count;
      if (!cart.item_count) {
        list.innerHTML = $('template[data-drawer-empty]', this.el).innerHTML;
        return;
      }
      list.innerHTML = cart.items.map(function (it, idx) {
        var line = idx + 1;
        var planLine = it.selling_plan_allocation ? it.selling_plan_allocation.selling_plan.name : (self.el.dataset.oneTimeLabel || 'One-time purchase');
        var opts = (it.options_with_values || []).filter(function (o) { return o.name !== 'Title'; }).map(function (o) { return o.value; }).join(' · ');
        var img = it.image ? '<img src="' + esc(sized(it.image, 200)) + '" alt="" width="88" height="88">' : '';
        return '<div class="line">' +
          '<a class="line__img" href="' + esc(it.url) + '" tabindex="-1" aria-hidden="true">' + img + '</a>' +
          '<div class="line__body">' +
          '<a class="line__title" href="' + esc(it.url) + '" style="text-decoration:none">' + esc(it.product_title) + (opts ? ' · ' + esc(opts) : '') + '</a>' +
          '<span class="line__plan">' + esc(planLine) + '</span>' +
          '<div class="line__foot">' +
          '<span class="qty"><button type="button" data-line="' + line + '" data-line-qty="' + (it.quantity - 1) + '" aria-label="Decrease quantity">−</button><span>' + it.quantity + '</span><button type="button" data-line="' + line + '" data-line-qty="' + (it.quantity + 1) + '" aria-label="Increase quantity">+</button></span>' +
          '<span>' + money(it.final_line_price) + '</span></div>' +
          '<button type="button" class="line__remove" data-line="' + line + '" data-line-qty="0">Remove</button>' +
          '</div></div>' + '<div data-upsell-slot="' + line + '"></div>';
      }).join('');

      /* "Switch & save" for one-time lines whose product offers a subscription */
      if (this.el.dataset.upsell !== 'false') {
        cart.items.forEach(function (it, idx) {
          if (it.selling_plan_allocation) return;
          self.planFor(it.handle).then(function (plan) {
            if (!plan) return;
            var slot = $('[data-upsell-slot="' + (idx + 1) + '"]', self.el);
            if (!slot) return;
            var pct = planPct(plan);
            var tpl = $('template[data-drawer-upsell]', self.el).innerHTML
              .replace(/\[pct\]/g, pct ? pct + '%' : '')
              .replace(/\[plan\]/g, esc(plan.name.toLowerCase()));
            slot.innerHTML = tpl;
            var b = $('button', slot);
            b.dataset.line = idx + 1;
            b.dataset.qty = it.quantity;
            b.dataset.linePlan = plan.id;
          });
        });
      }
    },
    planFor: function (handle) {
      if (!this.plansFor[handle]) {
        this.plansFor[handle] = json((D.routes.root || '/').replace(/\/?$/, '/') + 'products/' + handle + '.js')
          .then(function (p) {
            var groups = p.selling_plan_groups || [];
            if (!groups.length || !groups[0].selling_plans.length) return null;
            var plans = groups[0].selling_plans;
            return plans.find(function (x) { return /4/.test(x.name); }) || plans[0];
          }).catch(function () { return null; });
      }
      return this.plansFor[handle];
    }
  };
  function planPct(plan) {
    var adj = (plan.price_adjustments || [])[0];
    return adj && adj.value_type === 'percentage' ? adj.value : 0;
  }
  function setTextIn(root, sel, txt) { $$(sel, root).forEach(function (el) { el.textContent = txt; }); }
  window.DeccaCart = Cart;

  /* ---------- Nutrition tabs follow the buy module on the product page ---------- */
  function initNutrition() {
    $$('[data-nutri]').forEach(function (sec) {
      function show(key) {
        var panels = $$('[data-nutri-panel]', sec);
        if (!panels.some(function (p) { return p.dataset.nutriPanel === key; })) return;
        panels.forEach(function (p) { p.hidden = p.dataset.nutriPanel !== key; });
        $$('[data-nutri-tab]', sec).forEach(function (t) { t.setAttribute('aria-pressed', String(t.dataset.nutriTab === key)); });
      }
      sec.addEventListener('click', function (e) {
        var t = e.target.closest('[data-nutri-tab]');
        if (t) show(t.dataset.nutriTab);
      });
      document.addEventListener('decca:flavor', function (e) { if (e.detail && e.detail.key) show(e.detail.key); });
    });
  }

  /* ---------- "Have another." hides the current flavor ---------- */
  document.addEventListener('decca:flavor', function (e) {
    $$('[data-another-key]').forEach(function (el) { el.hidden = el.dataset.anotherKey === (e.detail && e.detail.key); });
    $$('[data-vs]').forEach(function (sec) {
      var f = e.detail && e.detail.flavor;
      if (!f) return;
      sec.style.setProperty('--vs-bg', f.swatch || '#4E3524');
      sec.style.setProperty('--vs-ink', f.ink || '#F4EFE2');
    });
  });
  document.addEventListener('click', function (e) {
    var a = e.target.closest('[data-another-pick]');
    if (!a) return;
    var mod = document.querySelector('[data-buy]');
    var btn = mod && mod.querySelector('[data-opt-index][data-value="' + a.dataset.anotherPick.replace(/"/g, '\\"') + '"]');
    if (btn) { e.preventDefault(); btn.click(); mod.scrollIntoView({ behavior: 'smooth' }); }
  });

  function init() {
    initNutrition();
    $$('[data-buy]').forEach(function (el) { try { new BuyModule(el); } catch (err) { console.error('Decca buy module', err); } });
    Cart.init();
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
})();
